import { Fragment, memo } from 'react';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { Element, RouterLink } from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Team } from '../team';
import { Score } from '../score';
import styles from './style.module.scss';

interface IProps {
    matches: IMatch[];
    isGroup?: boolean;
    renderRoundInDate?: boolean;
}

export function Matches({
    matches,
    renderRoundInDate = false,
    isGroup = false,
}: IProps) {
    const renderItem = (item: IMatch, index: number) => {
        return (
            <RouterLink
                to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
                className={styles['match-item']}
                key={index}
                title={item.home.team.name + ' đấu với ' + item.away.team.name}
            >
                <Team team={item.home.team} />
                <Score item={item} />
                <Team team={item.away.team} />
            </RouterLink>
        );
    };

    const renderItems = (matches: IMatch[] = []) => {
        return matches.map((item, index) => {
            return renderItem(item, index);
        });
    };

    const renderMatchRound = () => {
        const matchInRound = isGroup
            ? ArrayUtils.groupByGroup(matches)
            : ArrayUtils.groupByRound(matches);
        return Object.entries(matchInRound)?.map((matches: any, index) => {
            return (
                <Fragment key={index}>
                    <Element className={styles['match-label']}>
                        {matches[0]}
                    </Element>
                    {renderItems(matches[1])}
                </Fragment>
            );
        });
    };

    if (renderRoundInDate || isGroup) {
        return (
            <Element className={styles['match-items']}>
                {renderMatchRound()}
            </Element>
        );
    }

    return (
        <Element className={styles['match-items']}>
            {renderItems(matches)}
        </Element>
    );
}

export default memo(Matches);
